import { defineStore } from 'pinia';

export const useShiftStore = defineStore('shift', {
  state: () => ({
    shifts: {},
  }),
  actions: {
    addShift(shift) {
      this.shifts = shift;
    },
  },
});
